module.exports = __webpack_public_path__ + "static/img/peixunBannera.dbc8fbb5.png";